import React from 'react';

import { colors } from '@/assets/styles/colors';


interface ProgressBarProps {
  value: number;
  animated?: boolean;
  className?: string;
  'data-testid'?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  animated = true,
  className,
  'data-testid': testId,
}) => {
  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <div
      className={`w-full rounded-full h-2.5 overflow-hidden ${className ?? ''}`}
      style={{ backgroundColor: colors.grays.neutralEE }}
      role="progressbar"
      aria-valuenow={clampedValue}
      aria-valuemin={0}
      aria-valuemax={100}
      data-testid={testId}
    >
      <div
        className={`h-full rounded-full transition-all duration-500 ${animated ? 'animate-pulse' : ''}`}
        style={{ width: `${clampedValue}%`, backgroundColor: colors.feedback.success300 }}
      />
    </div>
  );
};

export default ProgressBar;
